import { render, staticRenderFns } from "./viewfarmers.vue?vue&type=template&id=5103af74"
import script from "./viewfarmers.vue?vue&type=script&lang=js"
export * from "./viewfarmers.vue?vue&type=script&lang=js"
import style0 from "./viewfarmers.vue?vue&type=style&index=0&id=5103af74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports